import { useLingui } from "@lingui/react/macro";
import { useId } from "react";

import type { DrillTopicView } from "../../model/Drill";
import { TopicCard } from "./TopicCard";

type TopicGridProps = { topics: DrillTopicView[] };

// «Твои темы» и как их считаем.
export const TopicGrid = ({ topics }: TopicGridProps) => {
  const { t } = useLingui();
  const headingId = useId();
  const now = new Date();
  if (topics.length === 0) {
    return null;
  }
  return (
    <section aria-labelledby={headingId} className="flex flex-col gap-3">
      <h2 id={headingId} className="font-display text-[26px]">
        {t`Your topics`}
      </h2>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-3">
        {topics.map((topic) => (
          <TopicCard key={topic.topic} topic={topic} now={now} />
        ))}
      </div>
      <p className="text-[13px] text-subtle">
        {t`“In drills”: a topic is understood after two right answers in a row. “In matches”: it is fixed when the mistake is gone from three analyses in a row; for death topics we also show survival by the quick rating of each match.`}
      </p>
    </section>
  );
};
